export const baseUrl = process.env.REACT_APP_WEB_API;
// "http://reconstream-dev-vm1.eastus.cloudapp.azure.com:8090/api";
// "https://reconstream-dev-api.timestreamgroup.com/api";

// export const baseUrlHttps = "https://reconstream-dev-vm1.eastus.cloudapp.azure.com:8090/api";
export const baseUrlHttps = process.env.REACT_APP_WEB_API;
// "https://reconstream-dev-api.timestreamgroup.com/api";
